import React, { useRef, useState } from 'react';
import Icon from '@/components/atoms/UI/Icon/Icon';
import IconButton from '@/components/atoms/UI/buttons/IconButton';
import styled, { keyframes } from 'styled-components';
import { radius, Spin } from '@/styles/template';
import { TextXS } from '@/pages/designSystem/Fonts';
import { useTranslation } from 'react-i18next';

interface Props {
	children: React.ReactNode
}



// code {
// 	width: 100%;
// 	overflow: auto;
// }

const Wrap = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  max-width: 100%;
  width: 100%;
  // background: ${(props) => props.theme.color.Background};
  box-shadow: inset 0 0 0 2px  ${(props) => props.theme.color.LightItem};
  border-radius: ${radius.normal};
  padding-left: 2rem;
`;

const SideToCopy = styled.div`
  color: ${props => props.theme.color.Text};
  flex-grow: 1;
  overflow-y: hidden;
  white-space: nowrap; 
  text-overflow: ellipsis;
  padding-right: 1rem;
  position: relative;
  text-align: left;
  width: 100%;
  overflow-x: auto;
  height: 100%;
  display: flex;
  align-items: center;
`;

const IconButtonCopy = styled(IconButton)`
	flex-shrink: 0;
	&.animate svg {
		-webkit-animation: ${Spin} 600ms;
		animation: ${Spin} 600ms;
	}
`;

const CopyTextInside: React.FC<Props> = ({ children }) => {
	const [isCopied, setIsCopied] = useState(false);
	const textRef = useRef<HTMLDivElement>(null);
	const { t } = useTranslation();
	const text_copied = t('copied');

	const handleCopy = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		if (textRef.current) {
			const plainText = textRef.current.innerText;

			navigator.clipboard.writeText(plainText)
			.then(() => {
				setIsCopied(true);

				setTimeout(() => {
					setIsCopied(false);
				}, 1000);
			})
			.catch((err) => {
				console.error('Failed to copy text: ', err);
			});
		}
	};

	return (
		<Wrap>
			<SideToCopy ref={textRef}>{isCopied ? <TextXS>{text_copied}</TextXS> : children}</SideToCopy>
			<IconButtonCopy large primary success={isCopied} onClick={handleCopy} className={`${isCopied && 'animate'}`}>
				{isCopied ? <Icon name={'Check'} xSmall /> : <Icon name={'Copy'} />}
			</IconButtonCopy>
		</Wrap>
	);
};

export default CopyTextInside;